import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const RequireUser = ({ children }) => {
  const location = useLocation();
  const [status, setStatus] = useState({ loading: true, authed: false });

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        if (!mounted) return;
        if (error) {
          setStatus({ loading: false, authed: false });
          return;
        }

        const session = data?.session;
        setStatus({ loading: false, authed: !!session?.user });
      } catch {
        if (!mounted) return;
        setStatus({ loading: false, authed: false });
      }
    };

    check();

    const { data: sub } = supabase.auth.onAuthStateChange(() => {
      check();
    });

    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe?.();
    };
  }, []);

  if (status.loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-sm text-muted-foreground">로딩 중...</div>
      </div>
    );
  }

  if (!status.authed) {
    return <Navigate to="/openplay/user-authentication" replace state={{ from: location?.pathname }} />;
  }

  return children;
};

export default RequireUser;
